import { Alert, Text } from "@findemdev/maui";
import styled from "styled-components";

export const AdditionalInfo = styled.span`
  color: ${({ theme }) => `${theme.colors["grey-500"]} !important`};
  background-color: white;
`;

export const IncompleteFormWarning = styled(Alert)`
  margin-top: ${({ theme }) => theme.dimensions.spacing["2"]};
  margin-bottom: ${({ theme }) => theme.dimensions.spacing["1"]};
`;

export const Label = styled.div``;

export const CapOrIndustryPracticeHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.dimensions.spacing["1"]};
  margin-bottom: ${({ theme }) => theme.dimensions.spacing["2"]};
`;

export const CapOrIndustryPracticeTitle = styled(Text)`
  color: ${({ theme }) => theme.colors["grey-700"]};
  font-size: 14px;
`;

export const RequiredMark = styled.span`
  color: ${({ theme }) => theme.colors["red-300"]};
  margin-left: 4px;
`;